module.exports = __webpack_public_path__ + "img/datacenter19.bb598919.png";